import React from 'react';
import { FaChartLine, FaClock, FaUser, FaBook } from 'react-icons/fa';
import { formatDate } from '../../../client/Utilities/FormatDate.js';
import './ProgressHistoryTable.css';


const ProgressHistoryTable = ({ data = [], usersData = []}) => {
  
  const calculateAverage = (items) => {
    if (!items || items.length === 0) return 0;
    const sum = items.reduce((acc, item) => acc + (item.testScore || 0), 0);
    return Math.round(sum / items.length);
  };

  const calculateTotalHours = (items) => {
    if (!items || items.length === 0) return '0.00';
    
    const total = items.reduce((acc, item) => {
      const hours = parseFloat(item.totalHours);
      return acc + (isNaN(hours) ? 0 : hours);
    }, 0);
    
    return typeof total === 'number' ? total.toFixed(2) : '0.00';
  };
  

  const enhancedData = Array.isArray(data) ? data.map(item => {
  // Find the user in usersData that matches the email
  const user = usersData.find(u => u.email === (item.transcriptEmail || item.email));
  return {
    ...item,
    email: item.transcriptEmail || item.email,
    userName: user ? user.name : 'Unknown User'  // Get name from usersData
  };
}) : [];

  // Group by email
  const groupedData = enhancedData.reduce((acc, item) => {
    if (!acc[item.email]) {
      acc[item.email] = {
        userName: item.userName,
        email: item.email,
        items: []
      };
    }
    acc[item.email].items.push(item);
    return acc;
  }, {});

  

  return (
    <div className="progress-history-view">
      {Object.values(groupedData).length > 0 ? (
        Object.values(groupedData).map((userGroup) => (
          <div key={userGroup.email} className="user-progress-section">
            <div className="user-header">
              <FaUser className="user-icon" />
              <div>
                <div className="user-name">{userGroup.userName}</div>
                <div className="user-email">{userGroup.email}</div>
              </div>
            </div>
            
            <div className="stats-header">
              <div className="stat-item">
                <FaChartLine className="stat-icon" />
                <span>Average Score: {calculateAverage(userGroup.items)}</span>
              </div>
              <div className="stat-item">
                <FaClock className="stat-icon" />
                <span>Total Hours: {calculateTotalHours(userGroup.items)}</span>
              </div>
            </div>

            <div className="history-timeline">
              {userGroup.items.map((item, index) => (
                <div key={index} className="timeline-item">
                  <div className="timeline-date">{item.lastTestDate ? formatDate(item.lastTestDate) : 'N/A'}</div>
                  <div className="timeline-content">
                    <div className="quiz-info">
                      <FaBook className="quiz-icon" />
                      <span>{item.lastQuizCompleted || 'N/A'}</span>
                    </div>
                    <div className="progress-stats">
                      <span className={`score-badge score-${Math.floor((item.testScore || 0)/10)*10}`}>
                        {item.testScore || 'N/A'}
                      </span>
                      <span className="hours-badge">
                        {item.totalHours ? parseFloat(item.totalHours).toFixed(2) : 'N/A'} hrs
                      </span>
                    </div>
                    {item.glaSummary && (
                      <div className="gla-summary">
                        {item.glaSummary.map((gla, i) => (
                          <span key={i} className="gla-tag">{gla.supportType || 'N/A'}</span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <div className="no-data-message">
          No progress history data available
        </div>
      )}
    </div>
  );
};

export default ProgressHistoryTable;